class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

 static renderProductCount(html) {

  // Removed or commented out the window reload
  // window.location.reload();

   // Initialize the slider logic for updating the max value display
  this.initializeSlider();
  this.setupLayoutButtons();
   
  
}

  // Define the method for slider initialization and value update
static initializeSlider() {
    const slider = document.querySelector('.range-slider');
    const draggable = slider.querySelector('.draggable');
    const input = document.querySelector('.slider-value');
    const max = parseInt(slider.getAttribute('data-max'), 10);
    const min = parseInt(slider.getAttribute('data-min'), 10);
    const total = document.querySelector('.total');

    let dragging = false;

    const updatePosition = (x) => {
        const rect = slider.getBoundingClientRect();
        let position = x - rect.left; // x position within the slider
        position = Math.max(position, 0); // Limit position to min 0
        position = Math.min(position, rect.width); // Limit position to max rect.width

        const value = min + (max - min) * (position / rect.width);
        const roundedValue = Math.round(value / 5) * 5; // Round value to nearest multiple of 5
        draggable.style.left = position + 'px';
        total.textContent = "£" + roundedValue + ".00"; // Display the value inside the draggable
        input.value = roundedValue;
        input.setAttribute('value', input.value); // Update the value attribute explicitly

        // Dispatch an input event
        input.dispatchEvent(new Event('input', { bubbles: true }));
    };

    // Handle mouse events
    draggable.addEventListener('mousedown', function(e) {
        dragging = true;
    });

    document.addEventListener('mousemove', function(e) {
        if (dragging) {
            updatePosition(e.clientX);
        }
    });

    document.addEventListener('mouseup', function(e) {
        dragging = false;
    });

    // Handle touch events
    draggable.addEventListener('touchstart', function(e) {
        dragging = true;
        e.preventDefault(); // Prevent default touch behavior (like scrolling)
    });

    document.addEventListener('touchmove', function(e) {
        if (dragging) {
            const touch = e.touches[0]; // Get the first touch
            updatePosition(touch.clientX);
        }
    });

    document.addEventListener('touchend', function(e) {
        dragging = false;
    });

    // Keyboard accessibility for arrow keys
    draggable.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            const increment = e.key === 'ArrowRight' ? 1 : -1;
            const currentValue = parseInt(input.value, 10);
            const newValue = Math.max(min, Math.min(max, currentValue + increment));
            input.value = newValue;
            input.setAttribute('value', input.value); // Update the value attribute explicitly
            const position = ((newValue - min) / (max - min)) * slider.offsetWidth;
            draggable.style.left = position + 'px';

            // Dispatch an input event
            input.dispatchEvent(new Event('input', { bubbles: true }));
        }
    });

}



  

static setupLayoutButtons() {
// Get references to the buttons and the target elements
const layout1Button = document.querySelector('.layout-1');
const layout2Button = document.querySelector('.layout-2');
const filterDrawerButtons = document.querySelectorAll('.filter-drawer');
const collectionGrid = document.querySelector('.collection-grid');
const facetWrapInner = document.querySelector('.facet-wrap-inner');
const facetBodyClass = document.body;

// Function to remove 'active-col' class from all filter drawer buttons
function removeActiveClassFromButtons() {
    filterDrawerButtons.forEach(button => {
        button.classList.remove('active-col');
    });
}

// Initialize the collection grid class based on localStorage
if (localStorage.getItem('columns-1') === 'true') {
    collectionGrid.classList.add('columns-1');
} else {
    collectionGrid.classList.remove('columns-1');
    layout2Button.classList.add('active-col');
}

// Add class 'columns-1' to .collection-grid when .layout-1 is clicked
layout1Button.addEventListener('click', function() {
    collectionGrid.classList.add('columns-1');
    localStorage.setItem('columns-1', 'true');
    localStorage.setItem('active-button', 'layout-1'); // Store active button in local storage
    removeActiveClassFromButtons(); // Remove 'active-col' class from all buttons
    layout1Button.classList.add('active-col'); // Add 'active-col' class to layout1Button
    layout2Button.classList.remove('active-col'); // Remove 'active-col' class from layout2Button
});

// Remove class 'columns-1' from .collection-grid when .layout-2 is clicked
layout2Button.addEventListener('click', function() {
    collectionGrid.classList.remove('columns-1');
    localStorage.setItem('columns-1', 'false');
    localStorage.setItem('active-button', 'layout-2'); // Store active button in local storage
    removeActiveClassFromButtons(); // Remove 'active-col' class from all buttons
    layout2Button.classList.add('active-col'); // Add 'active-col' class to layout2Button
    layout1Button.classList.remove('active-col'); // Remove 'active-col' class from layout1Button
});

// Add event listener to each filter drawer button
filterDrawerButtons.forEach(button => {
    button.addEventListener('click', function() {
        removeActiveClassFromButtons(); // Remove 'active-col' class from all buttons
        button.classList.add('active-col'); // Add 'active-col' class to clicked button
        localStorage.setItem('active-button', button.classList[1]); // Store active button in local storage
    });
});

// Retrieve active button from local storage and add 'active-col' class to it
const activeButton = localStorage.getItem('active-button');
if (activeButton) {
    document.querySelector(`.${activeButton}`).classList.add('active-col');
}



// Setup event listeners for each filter drawer button
filterDrawerButtons.forEach(button => {
    button.addEventListener('click', function(event) {
        if (event.target === button) { // Check if the event target is the button itself
            event.stopPropagation();
            facetWrapInner.classList.toggle('filter-visible');
            
            console.log(facetBodyClass.classList);

            // Get all <details> elements within the facetWrapInner and remove the 'open' attribute
            const detailsElements = facetWrapInner.querySelectorAll('details[open]');
            detailsElements.forEach(details => {
                details.removeAttribute('open');
            });
        }
    });
});

// Prevent <details> click from affecting outer elements
const detailsElements = document.querySelectorAll('details');
detailsElements.forEach(details => {
    details.addEventListener('click', function(event) {
        event.stopPropagation(); // Stop the click from bubbling up
    });
});
}


  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
